(function () {
  const deferredResources = [
    { "src": "youtube.com" },
    { "src": "storelocator" },
    { "src": "mbc-bundles"},
    { "src": "adcell.com", "load": "onUserInteract" },
    { "src": "bundle.9gtb.com", "load": "onUserInteract" },
    { "src": "shoplift", "load": "onUserInteract" },
    { "src": "pickystory", "load": "onUserInteract" },
    { "src": "cdn.doofinder.com" },
    { "src": "instafeed", "load": "onUserInteract" },
    { "src": "/assets/an_", "load": "onUserInteract" },
    { "href": "google-reviews.css", "load": "onUserInteract" }
  ];

  const blockedResources = [
    {
      "key": "src",
      "val": "storelocator",
      "getShouldBlock": () => { return document.querySelector('#scasl-app-container') == null }
    },
    {
      "key": "src",
      "val": "yotpo",
      "getShouldBlock": () => { return document.querySelector('.yotpo-widget-instance') == null }
    }
  ]

  // Funktion zum Blockieren von Ressourcen basierend auf den Blockierungskriterien
  function blockResources() {
    // Blockieren von Scripten
    var scripts = document.querySelectorAll('script[type="text/javascript"],script:not([type])');
    scripts.forEach(function (script) {
      const shouldBlock = shouldBlockResource(script);
      if (shouldBlock) {
        if(typeof shouldBlock == "string") {
          script.setAttribute('data-load', shouldBlock);
        }
        if(script.src) {
          script.setAttribute('data-src', script.src);
          script.src = '';
        }
        script.setAttribute('data-defer', "true");
        script.type= 'text/plain';
      }
    });
    var stylesheets = document.querySelectorAll('link[rel="stylesheet"]');
    stylesheets.forEach(function (stylesheet) {
      const shouldBlock = shouldBlockResource(stylesheet);
      if (shouldBlock) {
        if(typeof shouldBlock == "string") {
          stylesheet.setAttribute('data-load', shouldBlock);
        }
        stylesheet.setAttribute('data-href', stylesheet.href);
        stylesheet.href = '';
      }
    });
    var iframes = document.querySelectorAll('iframe');
    iframes.forEach(function (iframe) {
      const shouldBlock = shouldBlockResource(iframe);
      if (shouldBlock) {
        if(typeof shouldBlock == "string") {
          iframe.setAttribute('data-load', shouldBlock);
        }
        iframe.setAttribute('data-src', iframe.src);
        iframe.src = '';
      }
    });
  }

  // Funktion zum Überprüfen, ob eine Ressource blockiert werden soll
  function shouldBlockResource(resource) {
    for (var i = 0; i < deferredResources.length; i++) {
      var blockedResource = deferredResources[i];
      if(window.deferredDone != true || (blockedResource.load && !window.userInteracted)) {
        for (var key in blockedResource) {
          if (resource[key] && resource[key].indexOf(blockedResource[key]) !== -1) {
            return blockedResource.load || true;
          }
        }
      }
    }
    for (var i = 0; i < blockedResources.length; i++) {
      var blockedResource = blockedResources[i];
      if (blockedResource.getShouldBlock() && ((resource.hasAttribute(blockedResource.key) && resource.getAttribute(blockedResource.key).indexOf(blockedResource.val) !== -1) || (resource.hasAttribute("data-" + blockedResource.key) && resource.getAttribute("data-" + blockedResource.key).indexOf(blockedResource.val) !== -1))) {
        return true;
      }
    }
    return false;
  }

  function shouldBlockKeyValue(key, value) {
    for (var i = 0; i < deferredResources.length; i++) {
      var blockedResource = deferredResources[i];
      if(window.deferredDone != true || (blockedResource.load && !window.userInteracted)) {
        if (blockedResource[key] && value && value.indexOf && value.indexOf(blockedResource[key]) !== -1) {
          return blockedResource.load || true;
        }
      }
    }
    for (var i = 0; i < blockedResources.length; i++) {
      var blockedResource = blockedResources[i];
      if (blockedResource.getShouldBlock() && blockedResource.key == key && value && value.indexOf && value.indexOf(blockedResource.val) !== -1) {
        return true;
      }
    }
    return false;
  }

  // Funktion zum Nachladen von blockierten Ressourcen
  function reloadDeferredResources(load) {
    var blockedScripts = load ? document.querySelectorAll(`script[data-src][data-load="${load}"],script[data-defer][data-load="${load}"]`) : document.querySelectorAll('script[data-src]:not([data-load]),script[data-defer]:not([data-load])');
    blockedScripts.forEach(function (script) {
      if(!shouldBlockResource(script)) {
        var newScript = document.createElement('script');
        script.getAttributeNames().forEach((key) => {
          if (key != "data-src" && key != "data-defer" && key != "data-load") {
            const val = script.getAttribute(key);
            newScript.setAttribute(key, val);
          }
        })
        if (script.hasAttribute('data-src')) {
          if(!script.hasAttribute("defer") && !script.hasAttribute("async")) {
            script.setAttribute('defer', '');
          }
          newScript.src = script.getAttribute('data-src');
        } else {
          newScript.innerHTML = script.innerHTML;
        }
        newScript.type = "text/javascript"
        document.body.appendChild(newScript);
        script.remove();
      }
    });

    var blockedStylesheets = load ? document.querySelectorAll(`link[rel="stylesheet"][data-href][data-load="${load}"]`) : document.querySelectorAll('link[rel="stylesheet"][data-href]:not([data-load])');
    blockedStylesheets.forEach(function (stylesheet) {
      var newLink = document.createElement('link');
      newLink.rel = 'stylesheet';
      newLink.href = stylesheet.getAttribute('data-href') || stylesheet.href;
      newLink.media = 'print';
      newLink.onload = function() {
        this.media = 'all';
      };
      stylesheet.parentNode.removeChild(stylesheet);
      document.body.appendChild(newLink);
    });

    var blockedIframes = load ? document.querySelectorAll(`iframe[data-src][data-load="${load}"]`) : document.querySelectorAll('iframe[data-src]:not([data-load])');
    blockedIframes.forEach(function (iframe) {
      iframe.src = iframe.getAttribute('data-src');
      iframe.removeAttribute('data-src');
    });
  }

  function handleUserInteraction() {
    window.userInteracted = true;
    document.removeEventListener("scroll", handleUserInteraction);
    document.removeEventListener("click", handleUserInteraction);
    document.removeEventListener("touchstart", handleUserInteraction);
    setTimeout(() => {
      reloadDeferredResources("onUserInteract");
    }, 500);
  }

  const createElementBackup = document.createElement
  document.createElement = function (...args) {
    // If this is not a script tag, bypass
    if (args[0].toLowerCase() !== 'script' && args[0].toLowerCase() !== 'iframe')
      // Binding to document is essential
      return createElementBackup.bind(document)(...args)

    const el = createElementBackup.bind(document)(...args)

    // Backup the original setAttribute function
    const originalSetAttribute = el.setAttribute.bind(el)

    // Define getters / setters to ensure that the script type is properly set
    Object.defineProperties(el, {
      'src': {
        get() {
          return el.getAttribute('src')
        },
        set(value) {
          const shouldBlock = shouldBlockKeyValue('src', value.toString());
          if (shouldBlock) {
            if(typeof shouldBlock == "string") {
              originalSetAttribute('data-load', shouldBlock)
            }
            originalSetAttribute('data-src', value)
          } else {
            originalSetAttribute('src', value)
          }
          return true
        }
      },
      'href': {
        get() {
          return el.getAttribute('href')
        },
        set(value) {
          const shouldBlock = shouldBlockKeyValue('href', value.toString());
          if (shouldBlock) {
            if(typeof shouldBlock == "string") {
              originalSetAttribute('data-load', shouldBlock)
            }
            originalSetAttribute('data-href', value)
          } else {
            originalSetAttribute('href', value)
          }
          return true
        }
      }
    })

    // Monkey patch the setAttribute function so that the setter is called instead.
    // Otherwise, setAttribute('type', 'whatever') will bypass our custom descriptors!
    el.setAttribute = function (name, value) {
      if (name === 'src' || name === 'href')
        el[name] = value
      else
        (args[0] === 'script' ? HTMLScriptElement : args[0] === 'iframe' ? HTMLIFrameElement : HTMLLinkElement).prototype.setAttribute.call(el, name, value);
    }

    return el
  }

  // Blockieren von Ressourcen
  blockResources();

  document.onreadystatechange = function() {
    if (document.readyState === 'interactive') {
      blockResources();
    }
    if(document.querySelector("[data-load]")) {
      document.addEventListener("scroll", handleUserInteraction, { passive: true });
      document.addEventListener("touchstart", handleUserInteraction, { passive: true });
      document.addEventListener("click", handleUserInteraction);
    }
  };

  // Nachladen der blockierten Ressourcen
  window.addEventListener("DOMContentLoaded", function () {
    window.deferredDone = true;
    reloadDeferredResources();
  });

}());